import Box from "@mui/material/Box";
import MessageWithLogo from "components/MessageWithLogo";
import ShowLeaderboardCreateButton from "features/Leaderboards/components/ShowLeaderboardCreateButton";
import { useTranslation } from "react-i18next";

interface NoLeaderboardsMessageProps {}

function NoLeaderboardsMessage(props: NoLeaderboardsMessageProps) {
  const { t } = useTranslation();

  return (
    <Box>
      <MessageWithLogo>{t("leaderboard.no_leaderboards_message")}</MessageWithLogo>
      <Box
        sx={{
          pt: 2,
          pb: 16,
        }}
      >
        <ShowLeaderboardCreateButton />
      </Box>
    </Box>
  );
}

export default NoLeaderboardsMessage;
